
import { computed, defineComponent, onMounted, reactive, ref, watch } from 'vue';
import {
  CustomerRaffleParsed,
  CustomerRaffleTicket,
  RaffleParsed,
  RaffleSettings,
} from '@comsbi/common/src/types/models';
import { datetimeFormat } from '@/utils';
import dayjs from 'dayjs';
// import RaffleTicket from '@/components/organisms/raffle/RaffleTicket.vue';

export default defineComponent(
  /*<{ data?: CustomerRaffleParsed; master?: RaffleParsed; gotTicket?: boolean }> CS-8078 コンパイルできないためコメントアウト*/ {
    name: 'RafflePageContents',

    components: {
      /*RaffleTicket*/
    },

    props: {
      data: {
        type: Object,
        default: () => null,
      },
      master: {
        type: Object,
        default: () => null,
      },
      gotTicket: {
        type: Boolean,
        default: false,
      },
    },

    setup(props) {
      const settings = computed<RaffleSettings | undefined>(() => props.master?.settings);

      //
      const numOfUnusedTickets = computed(
        () => props.data?.contents.tickets.filter((item: CustomerRaffleTicket) => !item.used).length ?? 0
      );
      const maxOfTickets = computed(() => {
        return props.master ? props.master.settings.numOfTicketsForDraw : 0;
      });
      const numOfDraws = computed(() => {
        return Math.floor(numOfUnusedTickets.value / maxOfTickets.value);
      });
      const numOfUnusedTicketsAtRound = computed(() => {
        return numOfUnusedTickets.value % maxOfTickets.value;
        // 抽選券MAXの状態を見せたい場合は以下
        // if (numOfUnusedTickets.value === 0) return 0;
        // const v = numOfUnusedTickets.value % maxOfTickets.value;
        // return v === 0 ? maxOfTickets.value : v;
      });
      const termEnabled = computed(() => {
        if (!settings.value?.term) return true;
        const [from, to] = settings.value.term;
        const now = dayjs();
        if (from && now.isBefore(from)) return false;
        if (to && now.isAfter(to)) return false;
        return true;
      });

      const type = computed(() => {
        return settings.value?.type ?? undefined;
      });

      const numRequestTickets = ref(0);
      return {
        settings,

        numOfUnusedTickets,
        numOfUnusedTicketsAtRound,
        maxOfTickets,
        numOfDraws,
        termEnabled,
        type,

        //
        numRequestTickets,
        clearNumRequestTickets: () => {
          numRequestTickets.value = 0;
        },

        giveTicketsEnabled: computed(() => {
          const { ticketRestrictionType } = settings.value || {};
          if (!ticketRestrictionType) return true;
          if (ticketRestrictionType === 'UNLIMITED') return true;

          const numTickets = props.data?.contents.tickets.length ?? 0;
          if (ticketRestrictionType === 'ONCE' && numTickets > 0) return false;
          return true;
        }),

        // debug
        datetimeFormat,
      };
    },
  }
);
